{
	"wv_bizindiv_12m": [
		{
			"text": "Single seat license",
			"icon": "person",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "single",
				"text": "This is a single user plan"
			}
		},
		{
			"text": "Publish unlimited videos",
			"icon": "access_time",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "publish",
				"text": "The cumulative time of your completed/published videos"
			}
		},
		{
			"text": "4K Ultra HD resolution",
			"icon": "tv",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "resolution",
				"text": "The playback quality of your published video"
			}
		},
		{
			"text": "Premium editing features on desktop, iOS and Android",
			"icon": "movie_filter",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "premium",
				"text": "Green screen, screen recording, speed effects and licensed music"
			}
		},
		{
			"text": "Premium business motion titles",
			"icon": "font_download",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "motionPremium",
				"text": "Dozens of pro quality motion titles plus exclusive pro motion titles for business"
			}
		},
		{
			"text": "Create square, vertical and horizontal videos",
			"icon": "aspect_ratio",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "square",
				"text": "Maximize your real estate and traction with the best format for your destination"
			}
		},
		{
			"text": "Record screen and webcam together",
			"icon": "picture_in_picture_alt",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "screenwebcam",
				"text": "Create webinars, demos and more with screen and webcam recording"
			}
		},
		{
			"text": "Expanded social marketing options",
			"icon": "share",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "social",
				"text": "Direct upload and sharing to Twitter and Facebook"
			}
		},
		{
			"text": "Unlimited use of 1 million pieces of commercially licensed media",
			"icon": "star",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "licensed",
				"text": "WeVideo Essentials gets you unlimited use of 1 million pieces of pro quality commercially licensed videos, music and images",
				"newTooltip": false
			}
		},
		{
			"text": "Brand management",
			"icon": "colorize",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "brandmanagement",
				"text": "Save your logo to use as watermark, plus set brand colors and font preferences",
				"newTooltip": true
			}
		}
	],
	"wv_bizindiv_1m": [
		{
			"text": "Single seat license",
			"icon": "person",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "single",
				"text": "This is a single user plan"
			}
		},
		{
			"text": "Publish unlimited videos",
			"icon": "access_time",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "publish",
				"text": "The cumulative time of your completed/published videos"
			}
		},
		{
			"text": "4K Ultra HD resolution",
			"icon": "tv",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "resolution",
				"text": "The playback quality of your published video"
			}
		},
		{
			"text": "Premium editing features on desktop, iOS and Android",
			"icon": "movie_filter",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "premium",
				"text": "Green screen, screen recording, speed effects and licensed music"
			}
		},
		{
			"text": "Premium business motion titles",
			"icon": "font_download",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "motionPremium",
				"text": "Dozens of pro quality motion titles plus exclusive pro motion titles for business"
			}
		},
		{
			"text": "Create square, vertical and horizontal videos",
			"icon": "aspect_ratio",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "square",
				"text": "Maximize your real estate and traction with the best format for your destination"
			}
		},
		{
			"text": "Record screen and webcam together",
			"icon": "picture_in_picture_alt",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "screenwebcam",
				"text": "Create webinars, demos and more with screen and webcam recording"
			}
		},
		{
			"text": "Expanded social marketing options",
			"icon": "share",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "social",
				"text": "Direct upload and sharing to Twitter and Facebook"
			}
		},
		{
			"text": "Unlimited use of 1 million pieces of commercially licensed media",
			"icon": "star",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "licensed",
				"text": "WeVideo Essentials gets you unlimited use of 1 million pieces of pro quality commercially licensed videos, music and images",
				"newTooltip": false
			}
		},
		{
			"text": "Brand management",
			"icon": "colorize",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "brandmanagement",
				"text": "Save your logo to use as watermark, plus set brand colors and font preferences",
				"newTooltip": true
			}
		}
	],
	"wv_bizoct17_1m": [
		{
			"text": "Team license (includes 3 seats)",
			"icon": "people",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "team",
				"text": "Collaborate with team members in your organization"
			}
		},
		{
			"text": "Publish unlimited videos",
			"icon": "access_time",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "publish",
				"text": "The cumulative time of your completed/published videos"
			}
		},
		{
			"text": "4K Ultra HD resolution",
			"icon": "tv",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "resolution",
				"text": "The playback quality of your published video"
			}
		},
		{
			"text": "Premium editing features on desktop, iOS and Android",
			"icon": "movie_filter",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "premium",
				"text": "Green screen, screen recording, speed effects and licensed music"
			}
		},
		{
			"text": "Premium business motion titles",
			"icon": "font_download",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "motionPremium",
				"text": "Dozens of pro quality motion titles plus exclusive pro motion titles for business"
			}
		},
		{
			"text": "Create square, vertical and horizontal videos",
			"icon": "aspect_ratio",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "square",
				"text": "Maximize your real estate and traction with the best format for your destination"
			}
		},
		{
			"text": "Record screen and webcam together",
			"icon": "picture_in_picture_alt",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "screenwebcam",
				"text": "Create webinars, demos and more with screen and webcam recording"
			}
		},
		{
			"text": "Expanded social marketing options",
			"icon": "share",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "social",
				"text": "Direct upload and sharing to Twitter and Facebook"
			}
		},
		{
			"text": "Unlimited use of 1 million pieces of commercially licensed media",
			"icon": "star",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "licensed",
				"text": "WeVideo Essentials gets you unlimited use of 1 million pieces of pro quality commercially licensed videos, music and images",
				"newTooltip": false
			}
		},
		{
			"text": "Brand management",
			"icon": "colorize",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "brandmanagement",
				"text": "Save your logo to use as watermark, plus set brand colors and font preferences",
				"newTooltip": true
			}
		},
		{
			"text": "Create your own templates",
			"icon": "photo_library",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "templs",
				"text": "Build your brand and streamline your workflow with templates for your team"
			}
		},
		{
			"text": "Management and collaboration tools",
			"icon": "group_add",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "managementtools",
				"text": "Manage users and privacy, share media, and work with team members from anywhere at any time"
			}
		}
	],
	"wv_bizoct17_12m": [
		{
			"text": "Team license (includes 3 seats)",
			"icon": "people",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "team",
				"text": "Collaborate with team members in your organization"
			}
		},
		{
			"text": "Publish unlimited videos",
			"icon": "access_time",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "publish",
				"text": "The cumulative time of your completed/published videos"
			}
		},
		{
			"text": "4K Ultra HD resolution",
			"icon": "tv",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "resolution",
				"text": "The playback quality of your published video"
			}
		},
		{
			"text": "Premium editing features on desktop, iOS and Android",
			"icon": "movie_filter",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "premium",
				"text": "Green screen, screen recording, speed effects and licensed music"
			}
		},
		{
			"text": "Premium business motion titles",
			"icon": "font_download",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "motionPremium",
				"text": "Dozens of pro quality motion titles plus exclusive pro motion titles for business"
			}
		},
		{
			"text": "Create square, vertical and horizontal videos",
			"icon": "aspect_ratio",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "square",
				"text": "Maximize your real estate and traction with the best format for your destination"
			}
		},
		{
			"text": "Record screen and webcam together",
			"icon": "picture_in_picture_alt",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "screenwebcam",
				"text": "Create webinars, demos and more with screen and webcam recording"
			}
		},
		{
			"text": "Expanded social marketing options",
			"icon": "share",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "social",
				"text": "Direct upload and sharing to Twitter and Facebook"
			}
		},
		{
			"text": "Unlimited use of 1 million pieces of commercially licensed media",
			"icon": "star",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "licensed",
				"text": "WeVideo Essentials gets you unlimited use of 1 million pieces of pro quality commercially licensed videos, music and images",
				"newTooltip": false
			}
		},
		{
			"text": "Brand management",
			"icon": "colorize",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "brandmanagement",
				"text": "Save your logo to use as watermark, plus set brand colors and font preferences",
				"newTooltip": true
			}
		},
		{
			"text": "Create your own templates",
			"icon": "photo_library",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "templs",
				"text": "Build your brand and streamline your workflow with templates for your team"
			}
		},
		{
			"text": "Management and collaboration tools",
			"icon": "group_add",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "managementtools",
				"text": "Manage users and privacy, share media, and work with team members from anywhere at any time"
			}
		}
	],
	"wv_k12_6m": [
		{
			"text": "50 seat pack",
			"icon": "account_circle",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "licenses",
				"text": "Number of users that can be a part of your organization"
			}
		},
		{
			"text": "1Hr",
			"icon": "",
			"tooltip": {
				"hasTooltip": false,
				"dataFor": "",
				"text": ""
			}
		},
		{
			"text": "mo of publish time per seat",
			"icon": "access_time",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "publish",
				"text": "The cumulative time of your completed/published videos"
			}
		},
		{
			"text": "5 GB of cloud storage per seat",
			"icon": "storage",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "storage",
				"text": "Amount of storage space"
			}
		},
		{
			"text": "Publish in 720p",
			"icon": "tv",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "resolution",
				"text": "The playback quality of your published video"
			}
		},
		{
			"text": "Premium features",
			"icon": "movie_filter",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "premium",
				"text": "Green screen, screen recording, speed effects and licensed music"
			}
		}
	],
	"wv_k12_12m": [
		{
			"text": "30 seat pack",
			"icon": "account_circle",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "licenses",
				"text": "Number of users that can be a part of your organization"
			}
		},
		{
			"text": "1hr%2Fmo of publish time per seat",
			"icon": "access_time",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "publish",
				"text": "The cumulative time of your completed/published videos"
			}
		},
		{
			"text": "5 GB of cloud storage per seat",
			"icon": "storage",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "storage",
				"text": "Amount of storage space"
			}
		},
		{
			"text": "Publish in 720p",
			"icon": "tv",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "resolution",
				"text": "The playback quality of your published video"
			}
		},
		{
			"text": "Premium features",
			"icon": "movie_filter",
			"tooltip": {
				"hasTooltip": true,
				"dataFor": "premium",
				"text": "Green screen, screen recording, speed effects and licensed music"
			}
		}
	]
}
